import React, { Component } from 'react';
import styles from './social.css';
import Lang from '../../i18n'
import { withRouter } from 'react-router-dom'

class Social extends Component {
  render() {
    return (
      <div className={styles.inputWrapperContainer}>
        <div className={styles.inputWrapperContainerInner}>
          <div className={styles.titleContainer}>
            <div className={styles.titleInner}>
              <h2>{Lang.translate('social:title', this.props.location.pathname)}</h2>
              <p>{Lang.translate('social:text', this.props.location.pathname)}</p>
              
            </div>
          </div>
          <div id="instafeed" className={styles.socialFeed}></div>
          <a className={styles.btn} target="_blank" rel="noopener noreferrer" href={Lang.translate('social:link', this.props.location.pathname)}>{Lang.translate('social:button', this.props.location.pathname)}</a>
        </div>
      </div>

    );
  }
}

export default withRouter(Social);



// WEBPACK FOOTER //
// ./src/components/social/social.js